import {Exclude, Expose} from "class-transformer";

@Exclude()
export abstract class AbstractApiModel {
  @Expose() public '@context': string;
  @Expose() public '@type': string;
  @Expose() public '@id': string;
  @Expose() public id: number|string;
}
